// features/counter/counterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ISessionStateObject{
  sessionId: number,
  teamId: number,
  userId: number,
  gaminarCode: string
}

// Define a type for the slice state
interface SessionState {
  session: ISessionStateObject | null;
}

// Define the initial state using that type
const initialState: SessionState = {
    session: {sessionId : -1, teamId: -1, userId: -1, gaminarCode: ""},
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<ISessionStateObject>) => {
      state.session = action.payload;
      console.log("ASeccion", action.payload);
    }
  }
});

export const { setSession } = sessionSlice.actions;

export default sessionSlice.reducer;
